import { startLoading, stopLoading } from "@slices/loader.slice"
import { store } from "@store"
import axios from "axios"
import { toast } from "react-toastify"


const api = axios.create({
     // baseURL: "https://goldfish-app-xessi.ondigitalocean.app"
    // baseURL: "https://octopus-app-c2gy4.ondigitalocean.app/v1"
    // baseURL: "https://monkey-app-vuq4d.ondigitalocean.app"
    baseURL: "https://bd-noticeboard-dnroh.ondigitalocean.app"
  

    // baseURL: "http://localhost:8001/v1"
})

api.interceptors.request.use(
  (config) => {
    store.dispatch(startLoading())
    return config
  },
  (error) => {
    store.dispatch(stopLoading())
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading())

    if (response.status === 201) {
      toast.success(response.data)
    }

    return response
  },
  (error) => {
    store.dispatch(stopLoading())
    return Promise.reject(error)
  }
)

export default api
